// src/components/DonationWidget/AllDonationsModal.js (Example Path)
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // For the close button icon
import COLORS from '../../../../../../constants/colors'; // Adjust path as needed

const AllDonationsModal = ({ open, onClose, donations, formatAmount, formatTimestamp, campaignName }) => {

    // --- fmt function remains as originally provided ---
const fmt = (amt) => 'UGX ' + Math.floor(amt).toLocaleString();

const sentenceCase = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm" // Adjust max-width as needed
      PaperProps={{
        sx: {
          borderRadius: 4, // Match widget's border-radius
          boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" fontWeight="normal">
          All Donations for <strong>{sentenceCase(campaignName)}</strong>
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        {donations.length === 0 ? (
          <Box sx={{ p: 3 }}>
            <Typography variant="body1" color={COLORS.textSecondary}>
              No donations have been made for this campaign yet.
            </Typography>
          </Box>
        ) : (
          <List
            disablePadding
            sx={{
              width: '100%',
              maxHeight: '70vh', // Set a max height for the scrollable list in the modal
              overflowY: 'auto', // Enable scrolling
              p: 2, // Add padding inside the scrollable area
              // Custom scrollbar styles
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: COLORS.backgroundLight,
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: COLORS.primaryLight,
                borderRadius: '10px',
                '&:hover': {
                  background: COLORS.primary,
                },
              },
            }}
          >
            {donations.map((donation) => (
              <ListItem key={donation.id} disableGutters sx={{ mb: 1 }}>
                <ListItemText
                  primary={
                    <Typography variant="body2" color={COLORS.text}>
                      {fmt(donation.amount)} from{' '}
                      <Typography component="span" fontWeight="bold" color={COLORS.primary}>
                        {donation.donor}
                      </Typography>
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      {formatTimestamp(donation.timestamp)}
                    </Typography>
                  }
                  sx={{ m: 0 }}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AllDonationsModal;